var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgF18Mol(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 769,
    height: 161,
    viewBox: "0 0 769 161",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45.5391 45.6597H208.25L230.603 84.6479H391.235",
    stroke: "#007FAD",
    strokeWidth: 3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M95.7907 84.1874L73.263 45.1396L95.7907 6.0918H140.845L163.371 45.1396L140.845 84.1874H95.7907Z",
    fill: "#E6F2F7",
    stroke: "#007FAD",
    strokeWidth: 3
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M297.486 123.696L274.958 84.6479L297.486 45.6001H342.54L365.067 84.6479L342.54 123.696H297.486Z",
    fill: "#E6F2F7",
    stroke: "#007FAD",
    strokeWidth: 3
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M659.992 74.2519L682.865 61.2559L721.334 83.6091L741.608 70.613",
    stroke: "#007FAD",
    strokeWidth: 3
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M626.203 75.8105L603.33 62.8145L564.862 85.1677L544.588 72.1716",
    stroke: "#007FAD",
    strokeWidth: 3
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M426.062 74.7717L457.253 58.1367L482.725 88.8075L507.678 74.7717",
    stroke: "#007FAD",
    strokeWidth: 3
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M100.117 74.251H137.546",
    stroke: "#007FAD",
    strokeWidth: 4
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M136.508 13.4292L154.702 45.6595",
    stroke: "#007FAD",
    strokeWidth: 2
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M101.156 13.9492L82.9617 46.1795",
    stroke: "#007FAD",
    strokeWidth: 2
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M301.297 52.4189H338.726",
    stroke: "#007FAD",
    strokeWidth: 2
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M284.664 85.168L301.819 116.359",
    stroke: "#007FAD",
    strokeWidth: 2
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M338.727 115.839L355.881 84.6483",
    stroke: "#007FAD",
    strokeWidth: 2
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M204.609 54.4966L223.844 88.2864",
    stroke: "#007FAD",
    strokeWidth: 2
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M338 117.639H344.162L352.253 139.768H352.36V117.639H358.361V156.324H352.574L344.108 132.159H344.001V156.324H338V117.639Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M340.036 119.418H344.966L351.438 137.121H351.524V119.418H356.325V150.366H351.695L344.923 131.034H344.837V150.366H340.036V119.418Z",
    fill: "#212121"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M410.185 73.7321C416.741 73.7321 419.691 77.7573 419.691 84.5394V93.4168C419.691 100.75 416.522 104.5 410.185 104.5C403.794 104.5 400.68 100.585 400.68 93.6925V84.8702C400.68 77.4264 403.848 73.7321 410.185 73.7321ZM406.798 83.4366V94.7953C406.798 97.8279 407.945 99.427 410.185 99.427C412.48 99.427 413.572 97.7177 413.572 94.7953V83.4366C413.572 80.4591 412.48 78.8049 410.185 78.8049C408.164 78.8049 406.798 80.1283 406.798 83.4366Z",
    fill: "#212121"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M525.961 48.6992C532.516 48.6992 535.466 52.7244 535.466 59.5065V68.3839C535.466 75.7174 532.298 79.4669 525.961 79.4669C519.569 79.4669 516.455 75.552 516.455 68.6596V59.8373C516.455 52.3935 519.624 48.6992 525.961 48.6992ZM522.574 58.4037V69.7624C522.574 72.795 523.721 74.3941 525.961 74.3941C528.255 74.3941 529.348 72.6848 529.348 69.7624V58.4037C529.348 55.4262 528.255 53.772 525.961 53.772C523.94 53.772 522.574 55.0954 522.574 58.4037Z",
    fill: "#212121"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M644.425 73.7321C650.981 73.7321 653.931 77.7573 653.931 84.5394V93.4168C653.931 100.75 650.762 104.5 644.425 104.5C638.034 104.5 634.92 100.585 634.92 93.6925V84.8702C634.92 77.4264 638.088 73.7321 644.425 73.7321ZM641.038 83.4366V94.7953C641.038 97.8279 642.186 99.427 644.425 99.427C646.72 99.427 647.812 97.7177 647.812 94.7953V83.4366C647.812 80.4591 646.72 78.8049 644.425 78.8049C642.404 78.8049 641.038 80.1282 641.038 83.4366Z",
    fill: "#212121"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M749.905 41.6085H768.622V47.4589H756.613V57.5348H765.593V63.3853H756.613V80.72H749.905V41.6085Z",
    fill: "#212121"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M718.021 27.4482H721.003V62.1448H715.701V35.0322H711.062V31.8564C713.903 30.387 716.08 29.1072 718.021 27.4482Z",
    fill: "#212121"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M738.863 27.4482C743.975 27.4482 746.721 30.7188 746.721 37.023C746.721 39.7722 745.774 42.3317 743.644 43.8959C746.105 45.5075 747.194 47.6405 747.194 52.6175C747.194 59.1112 744.401 62.6188 738.863 62.6188C733.325 62.6188 730.533 59.1112 730.533 52.6175C730.533 47.6405 731.574 45.6023 734.083 43.8959C732 42.3791 731.006 39.7248 731.006 37.023C731.006 30.7188 733.799 27.4482 738.863 27.4482ZM736.307 36.786C736.307 40.104 737.065 41.4786 738.863 41.4786C740.662 41.4786 741.419 40.104 741.419 36.786C741.419 33.468 740.709 32.0934 738.863 32.0934C737.017 32.0934 736.307 33.5628 736.307 36.786ZM735.834 52.2857C735.834 55.8881 736.591 57.9736 738.863 57.9736C741.135 57.9736 741.893 55.8881 741.893 52.2857C741.893 48.3041 740.899 46.5977 738.863 46.5977C736.781 46.5977 735.834 48.3989 735.834 52.2857Z",
    fill: "#212121"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M0.625 26.0063H5.94025V38.6086H11.5984V26.0063H16.9137V56.9548H11.5984V43.238H5.94025V56.9548H0.625V26.0063Z",
    fill: "#212121"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M22.0575 26.0063H26.9869L33.4595 43.7096H33.5452V26.0063H38.3461V56.9548H33.7167L26.9441 37.6227H26.8583V56.9548H22.0575V26.0063Z",
    fill: "#212121"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M3.78906 3L19.6863 18.8973",
    stroke: "#007FAD",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgF18Mol);
export default __webpack_public_path__ + "static/media/f18mol.40a077259770071309dbe3bd3eb84c0f.svg";
export { ForwardRef as ReactComponent };